<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <el-card shadow="never">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Quote</span>
          <el-button
            size="mini"
            type="text"
            style="float: right;"
            @click.native="isHistoryVisible = true"
          >
            History ({{ quoteHistory.length }})
          </el-button>
        </div>

        <el-form
          size="small"
          label-position="top"
        >
          <el-row :gutter="15">
            <el-col :md="4">
              <el-card shadow="never">
                <div
                  slot="header"
                  class="clearfix"
                >
                  <span>Details</span>
                </div>
                <Details
                  :details="detail"
                  @set-default-address="setDefaultAddress"
                />
              </el-card>
            </el-col>
            <el-col :md="20">
              <el-row
                :gutter="15"
                class="mb-3"
              >
                <el-col :md="12">
                  <el-card shadow="never">
                    <div
                      slot="header"
                      class="clearfix"
                    >
                      <span>Sender</span>
                    </div>
                    <Address
                      :account="quoteAccount"
                      :address="sender"
                      type="sender"
                    />
                  </el-card>
                </el-col>
                <el-col :md="12">
                  <el-card shadow="never">
                    <div
                      slot="header"
                      class="clearfix"
                    >
                      <span>Receiver</span>
                    </div>
                    <Address
                      ref="receiverAddress"
                      :account="quoteAccount"
                      :address="receiver"
                      type="receiver"
                      @set-suburb="handleSetReceiverSuburb"
                    />
                  </el-card>
                </el-col>
              </el-row>

              <el-card shadow="never">
                <div
                  slot="header"
                  class="clearfix"
                >
                  <span>Items</span>
                  <el-button
                    plain
                    size="mini"
                    type="text"
                    style="float: right;"
                    @click.native="addItem"
                  >
                    Add Item
                  </el-button>
                </div>

                <template v-if="items.length">
                  <Items
                    v-for="(item, index) in items"
                    ref="items"
                    :key="`quote-item-${index}`"
                    :item="item"
                    :index="index"
                    :item-types="itemtypes"
                    @remove="removeItem"
                  />
                </template>

                <el-empty
                  v-else
                  description="No items added"
                />

                <div class="quote-totals">
                  <span><strong>Total Items:</strong> {{ totals.count }}</span>
                  <span><strong>Total Weight:</strong> {{ totals.weight }} kg</span>
                  <span><strong>Total Volume:</strong> {{ totals.volume }} m3</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form>

        <ResultsDialog
          v-if="isShowingResults"
          ref="resultsDialog"
          :quotes="quotes"
          :services="carriersAndServices"
          @close="isShowingResults = false"
        />

        <el-dialog
          title="Quote History"
          width="1200px"
          :visible.sync="isHistoryVisible"
        >
          <el-table
            :data="quoteHistory"
            size="mini"
            stripe
          >
            <el-table-column
              label="Saved"
              prop="created_at"
              width="170"
              :formatter="(row, col, value) => value ? $moment(value).format('DD/MM/YYYY hh:mm a') : '-'"
            />
            <el-table-column
              label="Sender"
              :formatter="row => $_.get(row, 'payload.sender.suburb') || $_.get(row, 'payload.sender.name') || '-'"
            />
            <el-table-column
              label="Receiver"
              :formatter="row => $_.get(row, 'payload.receiver.suburb') || $_.get(row, 'payload.receiver.name') || '-'"
            />
            <el-table-column
              label="Items"
              width="80"
              :formatter="row => $_.get(row, 'payload.items.length', 0)"
            />
            <el-table-column
              label="Quotes"
              width="80"
              :formatter="row => $_.get(row, 'quotes.length', 0)"
            />
            <el-table-column
              label=""
              width="400"
              align="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click.native="restoreQuote(scope.row, false)"
                >
                  Retrieve
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  @click.native="restoreQuote(scope.row, true)"
                >
                  Retrieve + Results
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click.native="removeHistory(scope.$index)"
                >
                  Delete
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <template #footer>
            <el-button @click.native="isHistoryVisible = false">
              Close
            </el-button>
            <el-button
              type="danger"
              plain
              :disabled="!quoteHistory.length"
              @click.native="clearHistory"
            >
              Clear History
            </el-button>
          </template>
        </el-dialog>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import Address from '@/components/Application/Freight/Quote/Address'
import Details from '@/components/Application/Freight/Quote/Detail'
import Items from '@/components/Application/Freight/Quote/Items'
import Request, { POST } from '@/plugins/sdk/Request'
import ResultsDialog from '@/components/Application/Freight/Quote/Dialog'

export default {
  historyStorageKey: 'freight.quote.history.v1',
  components: {
    Address,
    Details,
    Items,
    ResultsDialog
  },
  data () {
    return {
      title: 'Quote',
      breadcrumb: {
        name: 'Quote',
        route: { name: 'freight-quote' }
      },
      carriersAndServices: [],
      items: [{ quantity: 1 }],
      itemtypes: [],
      isLoadingItemtypes: false,
      sender: {},
      receiver: {},
      detail: {
        date: new Date()
      },
      isLoadingResults: false,
      isShowingResults: false,
      quotes: [],
      isHistoryVisible: false,
      quoteHistory: []
    }
  },
  computed: {
    actions () {
      return [
        [
          {
            name: 'Clear',
            icon: ['fal', 'trash'],
            event: this.resetForm
          }
        ],
        [
          {
            name: 'Quote',
            icon: ['fal', 'dollar-sign'],
            event: this.quote,
            loading: this.isLoadingResults
          }
        ]
      ]
    },
    quoteAccount () {
      return this.$_.get(this.detail, 'team.account', {})
    },
    totals () {
      const aggregate = this.items.reduce((acc, item) => {
        acc.count += Number(item.quantity) || 0
        acc.weight += Number(item.weight) || 0
        acc.volume += Number(item.volume) || 0
        return acc
      }, { count: 0, weight: 0, volume: 0 })

      return {
        count: aggregate.count,
        weight: this.$_.round(aggregate.weight, 2),
        volume: this.$_.round(aggregate.volume, 3)
      }
    }
  },
  created () {
    this.loadItemTypes()
    this.loadHistory()
  },
  mounted () {
    this.$mousetrap.bind(['command+4', 'ctrl+4'], this.quote)
  },
  beforeDestroy () {
    this.$mousetrap.unbind(['command+4', 'ctrl+4'])
  },
  methods: {
    handleSetReceiverSuburb () {
      this.$nextTick(() => {
        this.$refs['items'][0].$refs['itemTypeSelect'].focus()
        this.$refs['items'][0].$refs['itemTypeSelect'].visible = true
      })
    },
    setDefaultAddress (address) {
      this.sender = { ...address }
      this.sender.suburb = address.suburb
      this.sender.state = address.state
      this.sender.postcode = address.postcode
      this.sender.country = address.country
      this.$refs['receiverAddress'].$refs['suburbInput'].focus()
    },
    historyKey () {
      return this.$options.historyStorageKey
    },
    serializePayload () {
      const payload = {
        sender: this.sender,
        receiver: this.receiver,
        details: this.detail,
        items: this.items
      }

      return JSON.parse(JSON.stringify(payload))
    },
    saveHistoryEntry () {
      try {
        const entry = {
          id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
          created_at: new Date().toISOString(),
          payload: this.serializePayload(),
          quotes: JSON.parse(JSON.stringify(this.quotes || []))
        }

        this.quoteHistory.unshift(entry)
        this.quoteHistory = this.quoteHistory.slice(0, 20)
        this.persistHistory()
      } catch {
        this.$message.warning('Unable to save quote history for this entry')
      }
    },
    persistHistory () {
      try {
        localStorage.setItem(this.historyKey(), JSON.stringify(this.quoteHistory))
      } catch {
        this.$message.warning('Unable to persist quote history')
      }
    },
    loadHistory () {
      try {
        const raw = localStorage.getItem(this.historyKey())
        if (!raw) return

        const parsed = JSON.parse(raw)
        this.quoteHistory = Array.isArray(parsed) ? parsed : []
      } catch {
        this.quoteHistory = []
      }
    },
    restoreQuote (historyItem, withResults = false) {
      const payload = this.$_.get(historyItem, 'payload', {})

      this.sender = this.$_.cloneDeep(this.$_.get(payload, 'sender', {}))
      this.receiver = this.$_.cloneDeep(this.$_.get(payload, 'receiver', {}))
      this.detail = this.$_.cloneDeep(this.$_.get(payload, 'details', {}))
      this.items = this.$_.cloneDeep(this.$_.get(payload, 'items', [{}]))

      if (!this.detail.date) {
        this.$set(this.detail, 'date', new Date())
      }

      this.items = this.items.map(item => {
        if (typeof item.quantity === 'undefined' || item.quantity === null || item.quantity === '') {
          item.quantity = 1
        }
        return item
      })

      if (!this.items.length) {
        this.items = [{ quantity: 1 }]
      }

      if (withResults) {
        this.quotes = this.$_.cloneDeep(this.$_.get(historyItem, 'quotes', []))
        this.isShowingResults = this.quotes.length > 0
      } else {
        this.isShowingResults = false
      }

      this.isHistoryVisible = false
    },
    removeHistory (index) {
      this.quoteHistory.splice(index, 1)
      this.persistHistory()
    },
    clearHistory () {
      this.quoteHistory = []
      this.persistHistory()
    },
    addItem () {
      this.items.push({ quantity: 1 })
      this.$nextTick(() => {
        const newItemIndex = this.items.length - 1
        this.$refs['items'][newItemIndex].$refs['itemTypeSelect'].focus()
        this.$refs['items'][newItemIndex].$refs['itemTypeSelect'].visible = true
      })
    },
    resetForm () {
      this.sender = {}
      this.receiver = {}
      this.detail = {
        date: new Date()
      }
      this.items = [{ quantity: 1 }]
      this.quotes = []
      this.isShowingResults = false
    },
    async loadItemTypes () {
      this.isLoadingItemtypes = true
      this
        .$sdk
        .dictionary_itemtype
        .list(builder => {
          builder.page = 1
          builder.limit = 1000
          builder.order = 'item_type_desc:asc'
        })
        .then(res => { this.itemtypes = res })
        .finally(() => { this.isLoadingItemtypes = false })
    },
    removeItem (index) {
      this.items.splice(index, 1)
      if (!this.items.length) {
        this.items.push({ quantity: 1 })
      }
    },
    async quote () {
      if (!this.items.length) {
        this.$message.warning('Add at least one item before requesting a quote')
        return
      }

      this.isLoadingResults = true
      this.isShowingResults = false
      this.quotes = []

      try {
        const request = Object.assign(new Request(), {
          _pathname: '/legacy/quote',
          method: POST,
          _body: JSON.stringify({ sender: this.sender, receiver: this.receiver, details: this.detail, items: this.items })
        })

        const res = await fetch(await request.build())
        const data = await res.json()

        if (data.cost_estimate) {
          this.quotes = Object.values(data.cost_estimate)
          this.saveHistoryEntry()
        }

        this.isShowingResults = true
      } catch {
        this.$message.error('Unable to generate quote results')
      } finally {
        this.isLoadingResults = false
      }
    }
  }
}
</script>

<style scoped>
.quote-subtitle {
  float: right;
  color: #909399;
  font-size: 12px;
}

.quote-totals {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #606266;
}
</style>
